class ProductInfoDrawer extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!this.dialog) return;

    this.lastTrigger = null;

    this.querySelectorAll('[data-option-drawer-close]').forEach((button) => {
      button.addEventListener('click', this.close.bind(this));
    });
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.close();
    });
    this.dialog.addEventListener('cancel', () => {
      this.lastTrigger?.setAttribute('aria-expanded', 'false');
    });

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest(
        `[data-info-drawer-trigger][aria-controls="${this.dialog.id}"]`
      );
      if (trigger) this.openTo(trigger);
    });
  }

  openTo(trigger) {
    const panelId = trigger.getAttribute('data-info-drawer-trigger');
    const panel = panelId && this.querySelector(`#${panelId}`);

    this.querySelectorAll('.product-info-accordion__item').forEach((details) => {
      details.open = details === panel;
    });

    this.lastTrigger?.setAttribute('aria-expanded', 'false');
    this.lastTrigger = trigger;
    trigger.setAttribute('aria-expanded', 'true');

    if (!this.dialog.open) this.dialog.showModal();
    panel?.scrollIntoView({ block: 'nearest' });
  }

  close() {
    if (!this.dialog.open) return;

    this.dialog.classList.add('option-drawer--closing');
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      this.dialog.classList.remove('option-drawer--closing');
      this.dialog.close();
      this.lastTrigger?.setAttribute('aria-expanded', 'false');
    };
    this.dialog.addEventListener('animationend', finish, { once: true });
    setTimeout(finish, 400);
  }
}

customElements.define('product-info-drawer', ProductInfoDrawer);
